import React, { ChangeEvent, FC, useCallback, useState } from 'react';
import { DateRange } from '@material-ui/pickers';
import { FormControl, Grid, IconButton, MenuItem } from '@material-ui/core';
import { SearchOutlined } from '@material-ui/icons';
import { useStyles } from './styles';
import { useCommonStyles } from '../../../../../styles';
import { DateRangeSelect, HamburgerIcon, MonthRangePicker, SelectControl } from '../../../../../components';
import { FiltersDialog } from './FiltersDialog';

interface Props {
  translation: any;
  dateRange: DateRange<Date>;
  handleDateRangeChange: (date: DateRange<Date>) => void;
  showButton?: boolean;
  handleButtonClick?: () => void;
  handlePeriodChange: (isDaily: boolean) => void;
  applyFilters: (isDaily: boolean) => void;
}

export const ReportsToolbar: FC<Props> = ({ translation, dateRange, handleDateRangeChange, handleButtonClick, showButton, handlePeriodChange, applyFilters }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const [selectedDateRange, setSelectedDateRange] = useState<DateRange<Date>>(dateRange);
  const [period, setPeriod] = useState<string>('Daily');
  const [openFilterDialog, setOpenFilterDialog] = useState(false);

  const requestReport = useCallback(() => {
    if (handleButtonClick) {
      handleButtonClick();
    }
  }, [handleButtonClick]);

  const onPeriodChange = (event: ChangeEvent<{ value: any }>) => {
    const period = event.target.value;
    setPeriod(period);
    if (period === 'Daily') {
      handlePeriodChange(true);
    } else {
      handlePeriodChange(false);
    }
  };

  return (
    <>
      <Grid container direction="row" justify="space-between" alignContent="center" alignItems="center" className={classes.desktopContainer} spacing={1}>
        <Grid item className={classes.filters}>
          <p className={commonClasses.formControlTitle}>{translation.text_6166}</p>
          {period === 'Daily' ? (
            <DateRangeSelect
              defaultValue={selectedDateRange}
              onRangeChange={(value) => {
                setSelectedDateRange(value);
                handleDateRangeChange(value);
              }}
            />
          ) : (
            <MonthRangePicker
              defaultValue={selectedDateRange}
              translation={translation}
              onRangeChange={(value) => {
                setSelectedDateRange(value);
                handleDateRangeChange(value);
              }}
            />
          )}
        </Grid>
        <Grid item className={classes.filters}>
          <p className={commonClasses.formControlTitle}>{translation.text_841}</p>
          <FormControl variant="outlined" className={commonClasses.formControl}>
            <SelectControl value={period} onChange={onPeriodChange} minWidth={97}>
              <MenuItem className={commonClasses.optionSelector} value="Daily">
                {translation.text_6421}
              </MenuItem>
              <MenuItem className={commonClasses.optionSelector} style={{ width: 'inherit' }} value="Monthly">
                {translation.text_6422}
              </MenuItem>
            </SelectControl>
          </FormControl>
        </Grid>
        <Grid item style={{ alignSelf: 'flex-end' }}>
          {showButton && (
            <IconButton onClick={requestReport}>
              <SearchOutlined style={{ color: '#030C21' }} />
            </IconButton>
          )}
        </Grid>
      </Grid>
      <Grid container direction="row" justify="space-between" className={classes.mobileContainer} alignItems="center">
        <Grid item xs={11}>
          <p className={commonClasses.formControlTitle}>{translation.text_6166}</p>
          {period === 'Daily' ? (
            <DateRangeSelect
              defaultValue={selectedDateRange}
              onRangeChange={(value) => {
                setSelectedDateRange(value);
                handleDateRangeChange(value);
              }}
            />
          ) : (
            <MonthRangePicker
              defaultValue={selectedDateRange}
              translation={translation}
              onRangeChange={(value) => {
                setSelectedDateRange(value);
                handleDateRangeChange(value);
              }}
            />
          )}
        </Grid>
        <Grid item xs={1}>
          <IconButton onClick={() => setOpenFilterDialog(true)}>
            <HamburgerIcon />
          </IconButton>
        </Grid>
      </Grid>

      <FiltersDialog
        key={Math.random()}
        selected={period}
        open={openFilterDialog}
        translation={translation}
        onClose={() => setOpenFilterDialog(false)}
        applyFilter={(isDaily) => {
          setOpenFilterDialog(false);
          setPeriod(isDaily ? 'Daily' : 'Monthly');
          applyFilters(isDaily);
        }}
      />
    </>
  );
};
